// LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid w-special pt-5">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 col-lg-8 order-lg-2 mb-4 mb-lg-0">
                        <h3>{t('homePage.presentation.subTitle')}</h3>
                        <h2 dangerouslySetInnerHTML={{ __html: t('homePage.presentation.title') as string }}></h2>
                        <div>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para') as string }}></p>
                            <ul className="row">
                                <li className="col-12 col-sm-6 mb-3 px-0">{t('homePage.presentation.list1Item1')}</li>
                                <li className="col-12 col-sm-6 mb-3 px-0">{t('homePage.presentation.list1Item2')}</li>
                                <li className="col-12 col-sm-6 mb-3 px-0">{t('homePage.presentation.list1Item3')}</li>
                                <li className="col-12 col-sm-6 mb-3 px-0">{t('homePage.presentation.list1Item4')}</li>
                            </ul>
                            <div className="text-right">
                                <Link to={'/chi-siamo'} className="btn btn-primary" title={t('homePage.presentation.btnTitle')as string}>
                                    {t('homePage.presentation.btnText')}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-10 col-lg-4 order-lg-1 text-center text-md-left position-relative">
                        <img src="/assets/images/inHome/presentation1.webp" alt={t('homePage.presentation.image1Alt') as string} className="img-fluid" />
                        <img src="/assets/images/inHome/presentation2.webp" alt={t('homePage.presentation.image2Alt') as string} className="d-none d-md-block"/>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;